import { render, staticRenderFns } from "./FaceRecognition1.vue?vue&type=template&id=e3460786&scoped=true&"
import script from "./FaceRecognition1.vue?vue&type=script&lang=js&"
export * from "./FaceRecognition1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3460786",
  null
  
)

export default component.exports